import { RealTimeProvider, type TimeProvider } from '@ai-swfactory/seams/interfaces'
import { createContext, useContext } from 'react'

const ClockContext = createContext<TimeProvider>(new RealTimeProvider())

export const useClock = (): TimeProvider => useContext(ClockContext)
